// Navigation module
// Import jQuery directly to ensure it's available
import $ from 'jquery';

"use strict";

var slideUpTransition = function slideUpTransition(element) {
  var hideClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "hidden";
  var isMainNav = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return element.each(function() {
    var $el = $(this);
    var height = $el.outerHeight();
    var transitions = {
      "-webkit-transition": "max-height 80ms cubic-bezier(0.390, 0.575, 0.565, 1.000)",
      "-moz-transition": "max-height 80ms cubic-bezier(0.390, 0.575, 0.565, 1.000)",
      transition: "max-height 80ms cubic-bezier(0.390, 0.575, 0.565, 1.000)",
    };
    $el.css(transitions);
    if (isMainNav) {
      $el.css("max-height", height);
    } else {
      $el.css("max-height", "0");
    }
    if (isMainNav) {
      setTimeout(function() {
        $el.css({
          "max-height": "0",
        });
      }, 1);
    }
    $el.addClass(hideClass);
  });
};
var slideDownTransition = function slideDownTransition(element) {
  var hideClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "hidden";
  var isMainNav = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return element.each(function() {
    var $el = $(this);
    $el.removeClass(hideClass);

    // Make element visible to calculate height. Remove transitions to get correct height on Safari.
    $el.css("transition", "none");
    $el.css("max-height", "none");
    var height = $el.outerHeight();

    // Set max-height back to zero before animation, add back transitions
    var transitions;
    if (isMainNav) {
      transitions = {
        "-webkit-transition": "max-height 80ms cubic-bezier(0.390, 0.575, 0.565, 1.000)",
        "-moz-transition": "max-height 80ms cubic-bezier(0.390, 0.575, 0.565, 1.000)",
        transition: "max-height 80ms cubic-bezier(0.390, 0.575, 0.565, 1.000)",
      };
    } else {
      transitions = {
        "-webkit-transition": "max-height 80ms cubic-bezier(0.390, 0.575, 0.565, 1.000) 80ms",
        "-moz-transition": "max-height 80ms cubic-bezier(0.390, 0.575, 0.565, 1.000) 80ms",
        transition: "max-height 80ms cubic-bezier(0.390, 0.575, 0.565, 1.000) 80ms",
      };
    }
    $el.css("max-height", "0");
    $el.css(transitions);
    setTimeout(function() {
      $el.css({
        "max-height": height,
      });
    }, 1);

    if (isMainNav) {
      setTimeout(function() {
        $el.css("transition", "none");
        $el.css({
          "max-height": "initial",
        });
      }, 80);
    }
  });
};

document.addEventListener("turbo:before-cache", function() {
  $(".nav [data-role='nav-dropdown-toggle']")
    .next(".sub-nav.sub-nav--show")
    .removeClass("sub-nav--show");
});

$(document).on("turbo:load", function(event) {
  var navToggle = $("#nav-toggle");
  var navToggleIcon = $("#nav-toggle-icon");
  var navMenu = $("#nav");
  var navDropdownToggle = $("[data-role='nav-dropdown-toggle']");
  navToggle.click(function(e) {
    if (navMenu.hasClass("nav--hidden")) {
      slideDownTransition(navMenu, "nav--hidden", true);
      navToggle.addClass("nav-toggle--active");
      navToggleIcon.addClass("nav-toggle__icon--active");
      setTimeout(function() {
        navToggleIcon.addClass("nav-toggle__icon--rotate");
      }, 80);
    } else {
      slideUpTransition(navMenu, "nav--hidden", true);
      navToggle.removeClass("nav-toggle--active");
      navToggleIcon.removeClass("nav-toggle__icon--rotate");
      setTimeout(function() {
        navToggleIcon.removeClass("nav-toggle__icon--active");
      }, 80);
    }
  });

  navDropdownToggle.on("click", function(e) {
    e.preventDefault();
    slideUpTransition(
      $(this)
        .parent()
        .siblings()
        .find(".sub-nav"),
      "sub-nav--hidden"
    );
    $(this)
      .parent()
      .siblings()
      .find(".nav-link--open")
      .removeClass("nav-link--open");
    $(this).toggleClass("nav-link--open");
    if (
      $(this)
        .next(".sub-nav")
        .hasClass("sub-nav--hidden")
    ) {
      slideDownTransition($(this).next(".sub-nav"), "sub-nav--hidden");
    } else {
      slideUpTransition($(this).next(".sub-nav"), "sub-nav--hidden");
    }
  });

  $(document).on("click", function(e) {
    if (!$(e.target).is("[data-role='nav-dropdown-toggle']")) {
      slideUpTransition(navMenu.find(".sub-nav"), "sub-nav--hidden");
      navMenu.find(".nav-link--open").removeClass("nav-link--open");
    }
  });
});

// Makes sure the navigation doesn't disappear when closed in mobile and screen
// is resized to desktop width.
var handleNavMediaQuery = function handleNavMediaQuery(mql) {
  var navMenu = $("#nav");
  if (mql.matches) {
    navMenu.show();
  }
};

var mql = window.matchMedia("(min-width: 768px)");
mql.addListener(handleNavMediaQuery);
handleNavMediaQuery(mql);
